import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    styleUrls: ['checkbox.component.scss'],
    template: `
        <label class="checkbox" [class.selected]="selected">
            <span class="checkbox__icon">
                <input type="checkbox" [(ngModel)]="selected">
            </span>
            <ng-content></ng-content>
        </label>
    `
})
export class CheckboxComponent {
    @Input() selected: boolean;
    @Output() change = new EventEmitter();
    constructor() {}
}
